import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_PARC_BEGIN = "FETCH_PARC_BEGIN"
export const FETCH_PARC_SUCCESS = "FETCH_PARC_SUCCESS"
export const FETCH_PARC_ERROR = "FETCH_PARC_ERROR"
export const FETCH_PARC_RESET = "FETCH_PARC_RESET"

export const fetchParcBegin = () => ({
	type: FETCH_PARC_BEGIN,
})

export const fetchParcSucces = (vehicules) => ({
	type: FETCH_PARC_SUCCESS,
	payload: { vehicules },
})

export const fetchParcError = (error) => ({
	type: FETCH_PARC_ERROR,
	payload: { error },
})

export function fetchParc(id = null) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchParcBegin())
		let url = `${URL}api/parc`
		if (Number(id)) url = `${url}?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchParcSucces(json))
			})
			.catch(catchApiError(dispatch, fetchParcError))
	}
}

export const FETCH_PARCCOLOR_BEGIN = "FETCH_PARCCOLOR_BEGIN"
export const FETCH_PARCCOLOR_SUCCESS = "FETCH_PARCCOLOR_SUCCESS"
export const FETCH_PARCCOLOR_ERROR = "FETCH_PARCCOLOR_ERROR"
export const FETCH_PARCCOLOR_RESET = "FETCH_PARCCOLOR_RESET"

export const fetchParcColorBegin = () => ({
	type: FETCH_PARCCOLOR_BEGIN,
})

export const fetchParcColorSucces = (redVehicules) => ({
	type: FETCH_PARCCOLOR_SUCCESS,
	payload: { redVehicules },
})

export const fetchParcColorError = (error) => ({
	type: FETCH_PARCCOLOR_ERROR,
	payload: { error },
})

export function fetchParcColor() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchParcColorBegin())
		let url = `${URL}api/parccolor`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchParcColorSucces(json))
			})
			.catch(catchApiError(dispatch, fetchParcColorError))
	}
}

// Résumé par lot { "<parc_id>": { total, en_retard } } — pour les badges compteur.
export const FETCH_PARCRESUME_BEGIN = "FETCH_PARCRESUME_BEGIN"
export const FETCH_PARCRESUME_SUCCESS = "FETCH_PARCRESUME_SUCCESS"
export const FETCH_PARCRESUME_ERROR = "FETCH_PARCRESUME_ERROR"

export const fetchParcResumeBegin = () => ({ type: FETCH_PARCRESUME_BEGIN })
export const fetchParcResumeSucces = (resume) => ({
	type: FETCH_PARCRESUME_SUCCESS,
	payload: { resume },
})
export const fetchParcResumeError = (error) => ({
	type: FETCH_PARCRESUME_ERROR,
	payload: { error },
})

export function fetchParcResume() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchParcResumeBegin())
		return fetch(`${URL}api/parc-resume`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchParcResumeSucces(json)))
			.catch(catchApiError(dispatch, fetchParcResumeError))
	}
}
